export class Utils {
  static today(): string {
    return new Date().toISOString().split('T')[0];
  }

  static todayPlusAWeek(): string {
    let date = new Date();
    date.setDate(new Date().getDate() + 7);
    return date.toISOString().split('T')[0];
  }

  static now(): string {
    return new Date().toLocaleTimeString('en-US', { hour12: false });
  }
}
